import { render, staticRenderFns } from "./OrganizationAvatar.vue?vue&type=template&id=a2865214"
import script from "./OrganizationAvatar.vue?vue&type=script&lang=ts"
export * from "./OrganizationAvatar.vue?vue&type=script&lang=ts"
import style0 from "./OrganizationAvatar.vue?vue&type=style&index=0&id=a2865214&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports